/**
 * CloudGenie design tokens — single source of truth for colors, spacing,
 * type scale and radii shared by www/finops/studio/id + the existing frontend.
 */

export const colors = {
  background:            '0 0% 4%',
  foreground:            '0 0% 98%',
  card:                  '0 0% 7%',
  cardForeground:        '0 0% 98%',
  popover:               '0 0% 7%',
  popoverForeground:     '0 0% 98%',
  primary:               '217 91% 60%',
  primaryForeground:     '0 0% 100%',
  finopsAccent:          '160 84% 39%',
  studioAccent:          '271 91% 65%',
  secondary:             '217 19% 17%',
  secondaryForeground:   '0 0% 98%',
  muted:                 '217 19% 17%',
  mutedForeground:       '215 14% 65%',
  accent:                '217 19% 17%',
  accentForeground:      '0 0% 98%',
  destructive:           '0 84% 60%',
  destructiveForeground: '0 0% 100%',
  border:                '240 4% 16%',
  input:                 '240 4% 16%',
  ring:                  '217 91% 60%',
  chart1: '217 91% 60%', chart2: '160 60% 45%', chart3: '30 80% 55%',
  chart4: '280 65% 60%', chart5: '340 75% 55%',
};

export const radii = { sm: '0.25rem', md: '0.375rem', lg: '0.5rem', xl: '0.75rem', '2xl': '1rem', full: '9999px' };

export const typography = {
  fontFamily: {
    sans:  "'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    mono:  "'JetBrains Mono', 'Fira Code', ui-monospace, monospace",
    display: "'Cal Sans', 'Inter', system-ui, sans-serif",
  },
  fontSize: {
    xs: '0.75rem', sm: '0.875rem', base: '1rem', lg: '1.125rem', xl: '1.25rem',
    '2xl': '1.5rem', '3xl': '1.875rem', '4xl': '2.25rem', '5xl': '3rem',
    '6xl': '3.75rem', '7xl': '4.5rem',
  },
  lineHeight: { tight: 1.15, snug: 1.35, normal: 1.55, relaxed: 1.75 },
};

export const spacing = {
  1: '0.25rem', 2: '0.5rem', 3: '0.75rem', 4: '1rem', 5: '1.25rem',
  6: '1.5rem', 8: '2rem', 10: '2.5rem', 12: '3rem', 16: '4rem',
  20: '5rem', 24: '6rem', 32: '8rem', 40: '10rem', 48: '12rem', 64: '16rem',
};

export const breakpoints = { sm: '640px', md: '768px', lg: '1024px', xl: '1280px', '2xl': '1536px' };

export const shadows = {
  card:   '0 1px 2px 0 rgb(0 0 0 / 0.4), 0 1px 3px -1px rgb(0 0 0 / 0.3)',
  pop:    '0 10px 25px -5px rgb(0 0 0 / 0.6), 0 8px 10px -6px rgb(0 0 0 / 0.5)',
  glow:   '0 0 24px 0 hsl(217 91% 60% / 0.35)',
  finops: '0 0 24px 0 hsl(160 84% 39% / 0.35)',
  studio: '0 0 24px 0 hsl(271 91% 65% / 0.35)',
};

export const brand = {
  name: 'CloudGenie',
  productWww:    'CloudGenie',
  productFinops: 'CloudGenie FinOps',
  productStudio: 'CloudGenie Studio',
  productBundle: 'CloudGenie Complete',
  currencyDefault: 'GBP',
  legalEntity: 'CloudGenie',
  supportEmail: 'hello@cloudgenie.co',
  salesEmail:   'sales@cloudgenie.co',
  finopsEmail:  'finops@cloudgenie.co',
  studioEmail:  'studio@cloudgenie.co',
  domain: 'cloudgenie.co',
};
